import type { ArticleForm } from '@/features/instructions/lib/articleDraft'
import { ContentTab } from '../tabs/ContentTab'

interface Props {
  form: ArticleForm
  update: <K extends keyof ArticleForm>(key: K, val: ArticleForm[K]) => void
  activeLang: 'ru' | 'en'
  disabled: boolean
}

export const ContentPanel = ({ form, update, activeLang, disabled }: Props) => {
  const isEn = activeLang === 'en'
  const titlePlaceholder = isEn ? 'Instruction title' : 'Заголовок инструкции'
  const contentPlaceholder = isEn
    ? 'Write something or type / for commands...'
    : 'Напишите что-нибудь или введите / для команд...'
  return (
    // Ключ по языку: редактор заново на смене языка, чтобы догрузка не легла в документ чужого языка.
    <ContentTab
      key={isEn ? 'en' : 'ru'}
      title={isEn ? (form.titleEn ?? '') : form.title}
      onTitleChange={(s) => {
        if (isEn) update('titleEn', s || null)
        else update('title', s)
      }}
      content={isEn ? (form.contentEn ?? '') : form.content}
      onContentChange={(s) => {
        if (isEn) update('contentEn', s || null)
        else update('content', s)
      }}
      titlePlaceholder={titlePlaceholder}
      contentPlaceholder={contentPlaceholder}
      disabled={disabled}
    />
  )
}
